import React, { useState, useRef, useEffect } from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { Link, useNavigate } from 'react-router-dom';

import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { getToken, setUserSession } from '../../helpers/Helper';
import { POST_FORGOT_PASSWORD, POST_RESET_PASSWORD } from '../../helpers/url_helper';
import { toast } from 'react-toastify';

import Auth_Img from './../../assets/img/auth_img.png';
import Logo from './../../assets/img/logo.svg';


const ForgotPassword = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (getToken()) {
            navigate("/dashboard");
        }
    }, [navigate])

    const simpleValidator = useRef(new SimpleReactValidator());
    const OtpValidator = useRef(new SimpleReactValidator());

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [otp_screen, SetOTP_screen] = useState(false);
    const [form_inputs, setInputs] = useState({ email: '', password: '', c_password: '', otp: '' });
    const [, forceUpdate] = useState();

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_FORGOT_PASSWORD, { 'email': form_inputs.email }, {});
            if (res_data.status) {
                SetOTP_screen(true);
                toast(res_data.message);
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // form submit event
    const verifyOtp = async (event) => {
        event.preventDefault();
        const formValid = OtpValidator.current.allValid()
        if (!formValid) {
            OtpValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_RESET_PASSWORD, form_inputs, {});
            if (res_data.status) {
                setUserSession(res_data.data.userInfo.token, res_data.data.userInfo);
                navigate("/dashboard");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }

    return (
        <>
            <div>

            </div>
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src={Auth_Img} className="img-fluid" alt="forgot password" width="700" />
                        </div>
                    </div>

                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">
                            <div className="app-brand mb-4">
                                <img src={Logo} alt='Logo' />
                            </div>
                            <h4 className="mb-2">Forgot Password? 🔒</h4>
                            <p className="mb-4">Enter your email and we'll send you instructions to reset your password</p>
                            {!otp_screen && <>
                                <form id="formAuthentication" className="mb-3" onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label for="email" className="form-label">Email</label>
                                        <input name="email" className="form-control" value={form_inputs.email} onChange={handleInputChange} placeholder="Enter Email Address" type="text" autoFocus />
                                        {simpleValidator.current.message('email', form_inputs.email, 'required|email')}
                                    </div>
                                    <button disabled={ButtonDisabled} className="btn btn-primary w-100">{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Send Reset Link</button>
                                </form>
                                <div className="text-center">
                                    <Link to="/" className="d-flex align-items-center justify-content-center">
                                        <i className="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                        Back to login
                                    </Link>
                                </div>
                            </>}

                            {otp_screen && <>
                                <form id="formAuthentication" className="mb-3" onSubmit={verifyOtp}>
                                    <div className="mb-3">
                                        <label for="email" className="form-label">Otp</label>
                                        <input name="otp" className="form-control" maxLength="6" value={form_inputs.otp} onChange={handleInputChange} placeholder="Enter OTP" type="text" />
                                        {OtpValidator.current.message('otp', form_inputs.otp, 'required|numeric|min:6')}
                                    </div>
                                    <div className="mb-3">
                                        <label for="email" className="form-label">Password</label>
                                        <input name="password" className="form-control" value={form_inputs.password} onChange={handleInputChange} placeholder="Enter New Password" type="password" />
                                        {OtpValidator.current.message('password', form_inputs.password, 'required')}
                                    </div>
                                    <div className="mb-3">
                                        <label for="email" className="form-label">Confirm Password</label>
                                        <input name="c_password" className="form-control" value={form_inputs.c_password} onChange={handleInputChange} placeholder="Enter Confirm Password" type="password" />
                                        {OtpValidator.current.message('confirm password', form_inputs.c_password, `required|in:${form_inputs.password}`, { messages: { in: `Passwords don't match.` } })}
                                    </div>
                                    <button disabled={ButtonDisabled} className="btn btn-primary w-100">{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Change Password</button>
                                </form>
                                <div className="text-center">
                                    <Link to="/" className="d-flex align-items-center justify-content-center">
                                        <i className="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                        Back to login
                                    </Link>
                                </div>
                            </>}


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ForgotPassword;